<app-event [screen]="'APPOINTMENTS'" [memberId]="memberId" (refresh)="onRefresh()"></app-event>